export enum AuthErrorCode {
  APP_DOMAIN_NOT_FOUND = 'APP_DOMAIN_NOT_FOUND',
  APP_NOT_CONFIGURED = 'APP_NOT_CONFIGURED',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export interface AuthErrorMetadata {
  integrationType?: 'salesforce' | 'zendesk' | 'slack' | 'hubspot';
  domain?: string;
  entityType?: string;
  entityId?: string;
}
